import {
  Parcel10Kg,
  Parcel1Kg,
  Parcel20Kg,
  Parcel2Kg,
  Parcel5Kg,
  ParcelTypesEnvelop,
  ParcelTypesLarge,
  ParcelTypesLetterbox,
  ParcelTypesMedium,
  ParcelTypesSmall,
} from '@dhl/illustrations'
import { Sx } from '@dhl/theme'
import { isDhlParcel, isExpress, isExpressEconomy } from '~/basket/model/utils/carrier'

const classes: Record<string, Sx> = {
  icon: (theme) => ({
    [theme.breakpoints.down('md')]: {
      height: '40px',
      width: '60px',
    },
    [theme.breakpoints.up('sm')]: {
      height: '67px',
      width: '100px',
    },
  }),
}

type Props = {
  optionKey: string
  carrier: string
}

export const ParcelTypeIcon = ({ optionKey, carrier }: Props) => {
  if (isDhlParcel(carrier) || isExpressEconomy(carrier)) {
    switch (optionKey) {
      case 'ENVELOPE':
        return <ParcelTypesEnvelop viewBox="0 0 255 170" sx={classes.icon} />
      case 'XXSMALL':
      case 'XSMALL':
        return <ParcelTypesLetterbox viewBox="0 0 255 170" sx={classes.icon} />
      case 'SMALL':
        return <ParcelTypesSmall viewBox="0 0 255 170" sx={classes.icon} />
      case 'MEDIUM':
        return <ParcelTypesMedium viewBox="0 0 255 170" sx={classes.icon} />
      case 'LARGE':
        return <ParcelTypesMedium viewBox="0 0 255 170" sx={classes.icon} />
      case 'XLARGE':
      case 'XXLARGE':
      case 'PALLET':
        return <ParcelTypesLarge viewBox="0 0 255 170" sx={classes.icon} />
      default:
        return <ParcelTypesMedium viewBox="0 0 255 170" sx={classes.icon} />
    }
  }
  if (isExpress(carrier)) {
    switch (optionKey) {
      case 'XSMALL':
        return <ParcelTypesEnvelop viewBox="0 0 255 170" sx={classes.icon} />
      case 'SMALL':
        return <Parcel1Kg viewBox="0 0 255 170" sx={classes.icon} />
      case 'MEDIUM':
        return <Parcel2Kg viewBox="0 0 255 170" sx={classes.icon} />
      case 'LARGE':
        return <Parcel5Kg viewBox="0 0 255 170" sx={classes.icon} />
      case 'XLARGE':
        return <Parcel10Kg viewBox="0 0 255 170" sx={classes.icon} />
      case 'XXLARGE':
        return <Parcel20Kg viewBox="0 0 255 170" sx={classes.icon} />
      default:
        return <ParcelTypesMedium viewBox="0 0 255 170" sx={classes.icon} />
    }
  }

  return <ParcelTypesMedium viewBox="0 0 255 170" sx={classes.icon} />
}
